var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FacialRecognitionWarning50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2164_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.237488 26.6416H45.3655V43.4124H0.237488V26.6416Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9257 41.0168H2.61267V32.6313H4.98783V38.6209H10.9257V41.0168ZM42.9903 41.0168H34.6773V38.6209H40.6152V32.6313H42.9903V41.0168Z",
    fill: "#00B8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9903 8.67301H40.6152V2.68343H34.6773V0.287598H42.9903V8.67301ZM4.98783 8.67301H2.61267V0.287598H10.9257V2.68343H4.98783V8.67301Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8649 24.2459C35.8649 25.5636 34.7961 26.6418 33.4897 26.6418C32.1834 26.6418 31.1146 25.5636 31.1146 24.2459C31.1146 22.9282 32.1834 21.8501 33.4897 21.8501C34.7961 21.8501 35.8649 22.9282 35.8649 24.2459ZM14.4885 24.2459C14.4885 25.5636 13.4197 26.6418 12.1133 26.6418C10.807 26.6418 9.73816 25.5636 9.73816 24.2459C9.73816 22.9282 10.807 21.8501 12.1133 21.8501C13.4197 21.8501 14.4885 22.9282 14.4885 24.2459Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4897 17.0583C33.4897 7.95413 12.1133 11.0687 12.1133 17.0583V25.4437C12.1133 31.4333 16.8636 36.225 22.8015 36.225C28.7394 36.225 33.4897 31.4333 33.4897 25.4437V17.0583Z",
    fill: "#FFB74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8015 6.2771C15.5573 6.2771 10.9257 12.1469 10.9257 19.4542V22.2094L13.3009 24.2458V18.2563L27.5518 13.4646L32.3021 18.2563V24.2458L34.6773 22.2094V19.4542C34.6773 14.6625 33.4897 9.87085 27.5518 8.67293L26.3642 6.2771H22.8015Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3642 24.2458C26.3642 24.9645 26.8392 25.4437 27.5518 25.4437C28.2643 25.4437 28.7394 24.9645 28.7394 24.2458C28.7394 23.527 28.2643 23.0479 27.5518 23.0479C26.8392 23.0479 26.3642 23.527 26.3642 24.2458ZM16.8636 24.2458C16.8636 24.9645 17.3386 25.4437 18.0512 25.4437C18.7637 25.4437 19.2387 24.9645 19.2387 24.2458C19.2387 23.527 18.7637 23.0479 18.0512 23.0479C17.3386 23.0479 16.8636 23.527 16.8636 24.2458Z",
    fill: "#784719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2321 26.6416C12.8258 32.0322 17.3386 36.2249 22.8015 36.2249C28.2644 36.2249 32.7772 32.0322 33.3709 26.6416H12.2321Z",
    fill: "#00E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.237488 26.6416H45.3655V29.0374H0.237488V26.6416Z",
    fill: "#18FFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2164_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9589 49.706H18.801C18.1477 49.706 17.5463 49.3539 17.221 48.7832C16.8966 48.2124 16.8984 47.5102 17.2274 46.9413L31.8063 21.206C32.1326 20.6416 32.7321 20.2942 33.38 20.2942C34.0278 20.2942 34.6274 20.6416 34.9545 21.206L49.5335 46.9413C49.8624 47.5102 49.8642 48.2124 49.5398 48.7832C49.2155 49.3539 48.6113 49.706 47.9589 49.706Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5576 44.3217C31.5576 44.0745 31.6004 43.8484 31.6879 43.6361C31.7736 43.4265 31.8966 43.2445 32.0551 43.092C32.2109 42.9376 32.4032 42.8172 32.6237 42.7308C32.846 42.6462 33.0957 42.6012 33.3745 42.6012C33.6533 42.6012 33.9048 42.6462 34.129 42.7308C34.3568 42.8172 34.549 42.9376 34.7049 43.092C34.8643 43.2445 34.9873 43.4265 35.0721 43.6361C35.1595 43.8484 35.2024 44.0745 35.2024 44.3217C35.2024 44.5699 35.1595 44.796 35.0721 45.0019C34.9864 45.2087 34.8634 45.387 34.7049 45.5423C34.549 45.6949 34.3568 45.8144 34.129 45.9026C33.9048 45.9872 33.6533 46.0295 33.3745 46.0295C33.0948 46.0295 32.846 45.9872 32.6237 45.9017C32.4032 45.8135 32.2109 45.694 32.0551 45.5414C31.8957 45.3861 31.7727 45.2078 31.6879 45.001C31.6004 44.7951 31.5576 44.569 31.5576 44.3217ZM34.7285 40.5148H32.0196L31.636 29.4854H35.1112L34.7285 40.5148Z",
    fill: "#5D4037"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2164_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.603,
    height: 43.7,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2164_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.24,
    height: 30,
    fill: "white",
    transform: "translate(16.7599 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FacialRecognitionWarning50);
export default __webpack_public_path__ + "static/media/icons8-facial-recognition-warning-50.8f6caa943b1ed2695f91ae2196c390b1.svg";
export { ForwardRef as ReactComponent };